export type BookingServiceRef = {
    id?: number;
    category?: boolean;
    [key: string]: unknown;
};

export type BookingEventWithServices = {
    service?: BookingServiceRef | null;
    multipleBookings?: Array<{ service?: BookingServiceRef | null }> | null;
};

export function getServicesFromBookingEvent(event?: BookingEventWithServices | null): BookingServiceRef[] {
    if (!event) {
        return [];
    }

    const bookings = event.multipleBookings?.length ? event.multipleBookings : [event];

    return bookings
        .map((booking) => booking?.service)
        .filter((service): service is BookingServiceRef => Boolean(service?.id));
}

export function includeMissingServices(
    services: BookingServiceRef[] | null | undefined,
    servicesToInclude: BookingServiceRef[] | null | undefined,
): BookingServiceRef[] {
    const existing = [...(services || [])];

    for (const service of servicesToInclude || []) {
        if (service?.id && !existing.some((item) => item.id === service.id)) {
            existing.push(service);
        }
    }

    return existing;
}

/**
 * Keep a booking's current service(s) in the list even after they were deleted
 * (hidden=true) so merchants can still edit those bookings.
 */
export function includeBookingServices(
    storeServices: BookingServiceRef[] | null | undefined,
    event?: BookingEventWithServices | null,
): BookingServiceRef[] {
    return includeMissingServices(storeServices, getServicesFromBookingEvent(event));
}

export function ensureBookingServicesAvailable(
    availableServices: BookingServiceRef[] | null | undefined,
    storeServices: BookingServiceRef[] | null | undefined,
    event?: BookingEventWithServices | null,
): BookingServiceRef[] {
    const extras = getServicesFromBookingEvent(event).map(
        (service) => (storeServices || []).find((item) => item.id === service.id) || service,
    );

    return includeMissingServices(availableServices, extras);
}
